'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.trackingHandler = trackingHandler;
exports.watchTrackingEvents = watchTrackingEvents;

var _immutable = require('redux-form/immutable');

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _messageBus = require('@wh/message-bus');

var _constants = require('../../constants');

var _selectors = require('../../selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(trackingHandler),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchTrackingEvents);
//compatibility to versions up to 0.15 of redux-sage


var takeEveryEffect = _effects.takeEvery || _reduxSaga.takeEvery;

function trackingHandler(action) {
  var payload, rootAction, newValue, _ref, eventSource, elementTypePartial, isApayTriggered, paymentMethod;

  return _regenerator2.default.wrap(function trackingHandler$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          payload = action.payload || {};
          rootAction = payload.action || {};
          newValue = rootAction.payload;

          //copy payload from redux-form action to main payload

          delete payload.action;
          if (newValue) {
            payload.payload = newValue;
          } else {
            delete payload.payload;
          }

          if (!(rootAction.type === _immutable.actionTypes.CHANGE && rootAction.meta.field !== _constants.QD_RF_FIELD_AMOUNT)) {
            _context.next = 7;
            break;
          }

          return _context.abrupt('return');

        case 7:
          if (!(rootAction.type === _immutable.actionTypes.FOCUS && rootAction.meta.field !== _constants.QD_RF_FIELD_CVV)) {
            _context.next = 9;
            break;
          }

          return _context.abrupt('return');

        case 9:
          _context.next = 11;
          return (0, _effects.select)(_selectors.initDataSelector);

        case 11:
          _ref = _context.sent;
          eventSource = _ref.eventSource;
          elementTypePartial = eventSource ? { ElementType: 'QD ' + eventSource } : {};
          _context.next = 16;
          return (0, _effects.select)(_selectors.getIsApplePayAvailable);

        case 16:
          isApayTriggered = _context.sent;

          if (!isApayTriggered) {
            _context.next = 21;
            break;
          }

          _context.t0 = 'APAY';
          _context.next = 24;
          break;

        case 21:
          _context.next = 23;
          return (0, _effects.select)(_selectors.activePaymentMethodTypeSelector);

        case 23:
          _context.t0 = _context.sent;

        case 24:
          paymentMethod = _context.t0;
          _context.next = 27;
          return (0, _messageBus.publish)(_constants.TRACKING_TOPIC_EVENT_PARTIAL, {
            event: action.event,
            payload: (0, _extends3.default)({}, payload, elementTypePartial, { PaymentMethod: paymentMethod })
          });

        case 27:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchTrackingEvents() {
  return _regenerator2.default.wrap(function watchTrackingEvents$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_TRACKING_EVENT, trackingHandler);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}